import { useFlag as useUnleashFlag } from '@unleash/proxy-client-react'
import { useEffect, useMemo } from 'react'

import { type DashboardExperiments } from '@/experiments'
import { Heap } from '@/monitoring/heap'
import { NewRelic } from '@/monitoring/newrelic'

export function useFlag(name: DashboardExperiments) {
  const flag = useUnleashFlag(name)

  const propertyName = useMemo(() => `exp_${name.replace('.', '_')}`, [name])

  useEffect(() => {
    Heap.addEventProperties({ [propertyName]: flag })
    NewRelic.setCustomAttribute(propertyName, String(flag))
  }, [propertyName, flag])

  return flag
}
